export default "__VITE_ASSET__BxytsiWW__"